export default __webpack_public_path__ + "static/media/razor.799e2f93.svg";